import(/* webpackMode: "eager" */ "/app/code/apps/web/app/global-error.tsx");
